import { useParams, Link } from 'react-router-dom';
import { useLocale, useT, withLocale } from '../i18n';
import { useApiData } from '../api/useApiData';
import { contentApi } from '../api/content';
import AsyncSection from '../components/shared/AsyncSection';
import { usePageContentId } from '../components/lisa/PageContext';

export default function IndustryDetail() {
  const { slug } = useParams<{ slug: string }>();
  const locale = useLocale();
  const t = useT();
  const state = useApiData(() => contentApi.industry(slug!, locale), [slug, locale]);

  usePageContentId(slug ? `industry:${slug}` : null);

  return (
    <section className="section" style={{ paddingTop: 160 }}>
      <div className="container">
        <AsyncSection
          state={state}
          render={(i) => (
            <>
              <div className="reveal is-visible">
                <Link to={withLocale('/', locale)}>{t('common.home')}</Link> / <Link to={withLocale('/industries', locale)}>{t('nav.industries')}</Link> / {i.name}
              </div>
              <h1 style={{ margin: '16px 0 24px' }}>{i.name}</h1>
              <div className="card-grid" style={{ gridTemplateColumns: '1fr 1fr' }}>
                <div className="card reveal is-visible">
                  <span className="eyebrow">Challenge</span>
                  <p className="body-lg" style={{ marginTop: 8 }}>
                    {i.challenge}
                  </p>
                </div>
                <div className="card reveal is-visible">
                  <span className="eyebrow">Opportunity</span>
                  <p className="body-lg" style={{ marginTop: 8 }}>
                    {i.opportunity}
                  </p>
                </div>
              </div>
              <p className="body-lg" style={{ marginTop: 32 }}>
                {i.solutionSummary}
              </p>

              <div className="section-head" style={{ marginTop: 64 }}>
                <h2>Related business lines</h2>
              </div>
              <div className="card-grid">
                {i.relatedSolutions.map((s) => (
                  <Link className="card reveal is-visible" style={{ padding: '16px 20px' }} to={withLocale(`/solutions/${s.slug}`, locale)} key={s.code}>
                    {s.code} — {s.name}
                  </Link>
                ))}
              </div>

              <div className="card cta-band reveal is-visible" style={{ marginTop: 64 }}>
                <h2>Ready to talk about {i.name}?</h2>
                <div className="hero-cta-row" style={{ justifyContent: 'center', marginTop: 16 }}>
                  <Link className="btn btn-primary btn-lg" to={withLocale('/assessment', locale)}>
                    {t('solutions.cta_start_assessment')}
                  </Link>
                  <button className="btn btn-secondary btn-lg" type="button" data-open-lisa>
                    {t('common.talk_to_lisa')}
                  </button>
                </div>
              </div>
            </>
          )}
        />
      </div>
    </section>
  );
}
